/**
 * Mock Key Stages and Year Groups
 */

import type { CpKeyStage, CpYearGroup } from '../../../types/curriculum_planning';

const now = Date.now();

export const mockCpKeyStages: CpKeyStage[] = [
  {
    id: 'ks-3',
    name: 'KS3',
    description: 'Key Stage 3 (Years 7-9)',
    createdAt: now,
  },
  {
    id: 'ks-4',
    name: 'KS4',
    description: 'Key Stage 4 (Years 10-11)',
    createdAt: now,
  },
];

export const mockCpYearGroups: CpYearGroup[] = [
  {
    id: 'yg-7',
    name: 'Year 7',
    shortName: 'Y7',
    displayOrder: 1,
    keyStageId: 'ks-3',
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'yg-8',
    name: 'Year 8',
    shortName: 'Y8',
    displayOrder: 2,
    keyStageId: 'ks-3',
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'yg-9',
    name: 'Year 9',
    shortName: 'Y9',
    displayOrder: 3,
    keyStageId: 'ks-3',
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'yg-10',
    name: 'Year 10',
    shortName: 'Y10',
    displayOrder: 4,
    keyStageId: 'ks-4',
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'yg-11',
    name: 'Year 11',
    shortName: 'Y11',
    displayOrder: 5,
    keyStageId: 'ks-4',
    createdAt: now,
    updatedAt: now,
  },
];
